const highContrastButton = document.querySelector( '.button--high-contrast' );

const bindHighContrastButtonClick = () => {
  highContrastButton.addEventListener( 'click', event => {
    event.preventDefault();

    const bodyHasHighContrast = document.body.classList.contains( 'high-contrast' );

    saveHighContrastPreference( !bodyHasHighContrast );
    maybeEnableHighContrast();
  } );
}

const maybeEnableHighContrast = () => {
  const prefersHighContrast = getHighContrastPreference();

  if (prefersHighContrast) {
    document.body.classList.add( 'high-contrast' );
    highContrastButton.setAttribute( 'aria-pressed', 'true' );
  } else {
    document.body.classList.remove( 'high-contrast' );
    highContrastButton.setAttribute( 'aria-pressed', 'false' );
  }
}

const getHighContrastPreference = () => {
  try {
    return localStorage.getItem( 'highContrast' ) === 'true';
  } catch (e) {
    return false;
  }
}

const saveHighContrastPreference = (isHighContrast) => {
  localStorage.setItem( 'highContrast', isHighContrast );
}

const highContrast = () => {
  if (!highContrastButton) {
    return;
  }

  maybeEnableHighContrast();
  bindHighContrastButtonClick();
}

export default highContrast;
